<template>
    <Column
        :xs-size="xsSize"
        :sm-size="smSize"
        :md-size="mdSize"
        :lg-size="lgSize"
        :xl-size="xlSize"
        :no-margin-top="noMarginTop"
    >
        <LabelTag :class="marginBottom" :style="labelStyle"> {{ $t(label) }}</LabelTag>
        <SelectTag
            :options="customOptions"
            :model-form="modelForm"
            :model-name="modelName"
            :value-field="valueField"
            :text-field="textField"
        />

        <InvalidForm :state="this[checkToModel](modelName)" :text="errors[modelName]"/>
    </Column>
</template>

<script>
import validatorMixin from "../mixin/validatorMixin";
import SelectTag from "./html/SelectTag";
import Column from "./html/Column";
import InvalidForm from "./html/InvalidForm";
import LabelTag from "./html/LabelTag";
import sizeClassesMixin from "./html/mixin/sizeClassesMixin";
import {mapGetters} from "vuex";

export default {
    name: "SelectBox",
    components: {LabelTag, InvalidForm, Column, SelectTag},
    mixins: [validatorMixin, sizeClassesMixin],
    props: {
        errors: {
            type: Object,
            required: true,
        },
        label: {
            type: String,
        },

        // optional
        options: {
            type: Array,
            required: false,
            default: null,
        },
        checkToModel: {
            type: String,
            default: "modelChooseIdState"
        },
        fetchName: {
            type: String,
            default: undefined,
        },
        getterName: {
            type: String,
            default: undefined,
        },
        afterFetch: {
            type: Function,
            default: (items) => {
                console.log(items)
            }
        },
        noMarginTop: {
            type: Boolean,
            default: true
        },
        modelName: {
            type: String,
        },
        modelForm: {
            type: Object,
            // required: true,
        },
        valueField: {
            type: String,
            default: "id",
        },
        textField: {
            type: String,
            default: "name",
        },
        labelStyle: {
            type: String,
            default: '',
        },
        marginBottom: {
            type: String,
            default: '',
        }
    },
    computed: {
        ...mapGetters(['getEmployeePositions'])
    },
    mounted() {
        if (this.options !== null) {
            this.customOptions = this.options
            return;
        }

        if (this.getterName === undefined) {
            console.error('You must specify data or getterName prop')
            return
        }

        if (this.fetchName !== undefined) {
            this.$root.showOverlay = true
            let data = null

            if (this.fetchName === 'fetchEmployeePositions') {
                data = {page: 1}
            }

            this.$store
                .dispatch(this.fetchName, data)
                .then(() => {
                    this.customOptions = this.getData()
                    this.afterFetch(this.customOptions)
                })
                .finally(() => {
                    this.$root.showOverlay = false
                })
        }
    },
    methods: {
        getData() {
            return this.$store.getters[this.getterName]
        }
    },
    data() {
        return {
            customOptions: []
        }
    },
    watch: {
        'getEmployeePositions'() {
            this.customOptions = this.getData()
        }
    }
}
</script>
